<template>
  <template-user-liked-item-list-page></template-user-liked-item-list-page>
</template>

<script lang="ts">

import templateUserLikedItemListPage from '@/app-template/lib/pages/UserLikedItemListPage.vue';

export default {
  name: "UserLikedItemListPage",
  components: { templateUserLikedItemListPage },
};
</script>